<div *ngIf="formGroup">
  <form [formGroup]="formGroup" formFocusable>
    <app-default-card
      [title]="'Uploads'"
      [info]="'Sie haben hier die Möglichkeit Dokumente hochzuladen.'"
      [showThisComponent]="formGroup.controls['uploads']"
      [showChildComponent]="true">
      <app-upload-documents
        [inputFormArray]="formGroup.controls['uploads']"
        [documentTag]="'chimneySweeper'"
        [showTag]="false"
        [canUpdate]="true"
        [filterCriteria]="'equal'"
        [numberOfUploads]="10"
        [editUpload]="true"
        [showUploadButton]="true"
        (uploaded)="uploadDocument($event)"></app-upload-documents>
    </app-default-card>

    <app-default-card
      [title]="'Einverständniserklärung'"
      [info]="'Bitte bestätigen Sie hier, dass Sie die Daten des Antrags geprüft haben.'"
      [showThisComponent]="true"
      [showChildComponent]="true">
      <app-accept-conditions
        [inputForm]="formGroup"
        [controlName]="'formConfirmation'"
        [disable]="false"
        [inputLink]=""
        [inputText]="
          ('commissioning.chimneySweepConfirmation.confirmationText' | uiAdaptionVisible)
            ? ('commissioning.chimneySweepConfirmation.confirmationText' | uiAdaptionValue)
            : 'Hiermit erkläre(n) ich/wir, dass ich/wir die oben genannten Daten zur Feuerstätte geprüft habe(n) und die Anlage freigeben wird.'
        "></app-accept-conditions>
    </app-default-card>
  </form>
</div>
